import React, { useState } from 'react';
import { Checkbox, Button, Modal } from 'antd';
import './termsConditionsAcceptance.css';

const TermsConditionsAcceptance = ({ tycData, onAccept, onReject, isSubmitting }) => {
    const [checked, setChecked] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);

    if (!tycData) return null;

    const processContent = (html) => {
        if (!html) return '';
        let processed = html.replace(
            /\[NOMBRE DE LA EMPRESA CLIENTE\]/g,
            `<strong>${tycData.org_name || 'la empresa'}</strong>`
        );
        // Eliminar cualquier <a> existente alrededor de la URL de política de datos
        // (ReactQuill puede auto-generar anchors rotos) y reconstruirlo limpio.
        processed = processed.replace(
            /<a[^>]*>([^<]*mentoringconsultores\.com\/politica-de-datos[^<]*)<\/a>/gi,
            'www.mentoringconsultores.com/politica-de-datos'
        );
        // Ahora convertir la URL plana en un enlace correcto
        processed = processed.replace(
            /(?<!href=["'])www\.mentoringconsultores\.com\/politica-de-datos/g,
            '<a href="https://www.mentoringconsultores.com/politica-de-datos" target="_blank" rel="noopener noreferrer">www.mentoringconsultores.com/politica-de-datos</a>'
        );
        return processed;
    };

    const handleAccept = () => {
        if (checked && onAccept) {
            onAccept();
        }
    };

    const handleRejectClick = async () => {
        setIsRejecting(true);
        if (onReject) {
            await onReject();
        }
        setIsRejecting(false);
        setShowRejectModal(true);
    };

    return (
        <div className="tyc-acceptance-container">
            <div className="tyc-acceptance-scroll-area">
                <div
                    className="tyc-acceptance-content"
                    dangerouslySetInnerHTML={{ __html: processContent(tycData.tcc_content) }}
                />
            </div>

            <div className="tyc-acceptance-footer">
                <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                    className="tyc-acceptance-checkbox"
                >
                    <span className="tyc-acceptance-checkbox-text">
                        He leído y comprendo esta autorización. Acepto de manera libre, voluntaria,
                        previa, expresa e informada el tratamiento de mis datos personales,
                        incluyendo aquellos que puedan considerarse sensibles y la transmisión
                        internacional de los mismos, conforme a lo descrito anteriormente y a la
                        Política de Tratamiento de Datos Personales de Mentoring Consultores S.A.S.
                        (Talentha®).
                    </span>
                </Checkbox>

                <Button
                    type="primary"
                    size="large"
                    block
                    disabled={!checked || isSubmitting}
                    loading={isSubmitting}
                    onClick={handleAccept}
                    className={`tyc-acceptance-button ${checked ? 'tyc-acceptance-button-active' : ''}`}
                >
                    ACEPTO Y CONTINÚO
                </Button>

                <Button
                    type="default"
                    size="large"
                    block
                    disabled={isSubmitting || isRejecting}
                    loading={isRejecting}
                    onClick={handleRejectClick}
                    className="tyc-reject-button"
                >
                    NO ACEPTO
                </Button>
            </div>

            <Modal
                open={showRejectModal}
                closable={false}
                maskClosable={false}
                footer={null}
                centered
                className="tyc-reject-modal"
            >
                <div className="tyc-reject-modal-content">
                    <p className="tyc-reject-modal-text">
                        Sin esta autorización no es posible continuar con el proceso.
                    </p>
                    <p className="tyc-reject-modal-text">
                        Si tienes dudas escríbenos a:{' '}
                        <a href="mailto:gerencia@mentoringconsultores.com">
                            gerencia@mentoringconsultores.com
                        </a>
                    </p>
                    <Button
                        type="primary"
                        size="large"
                        block
                        onClick={() => setShowRejectModal(false)}
                        className="tyc-reject-modal-button"
                    >
                        Regresar y aceptar
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default TermsConditionsAcceptance;
